import WithdrawalModal from '@features/games/withdrawal/withdrawal-modal';
export default WithdrawalModal;
